/* Template: Navigation
   ========================================================================== */

template.component.nav = function() {

	const window_width = window.innerWidth;
	const $menu_item_children_link = $('.main-navigation .menu-item-has-children > a');
	const $menu_toggle_btn = $('#menu-toggle');
	const $main_navigation = $('.main-navigation');
	const menu_toggle_open = 'menu-toggle__open';
	const $search_toggle_btn = $('.search-toggle');
	const $search = $('.search-container');
	const search_toggle_open = 'search-toggle__open';

	// Add aria attributes
	$menu_item_children_link.each(function() {
		$(this).attr('aria-haspopup', 'true').attr('aria-expanded', 'false');
	});

	if (window_width < 768) {

		// Resets
		$menu_toggle_btn.html('<span>Menu</span>').removeClass(menu_toggle_open).attr('aria-expanded', 'false');
		$main_navigation.hide();
		$search_toggle_btn.removeClass(search_toggle_open).attr('aria-expanded', 'false');
		$search.hide();

		// Menu toggle
		$menu_toggle_btn.unbind().click(function() {

			if ($main_navigation.is(':visible') || $search.is(':visible')) {
				$(this).html('<span>Menu</span>');
				$main_navigation.hide();
				$(this).removeClass(menu_toggle_open).attr('aria-expanded', 'false');
				$search.hide();
				$search_toggle_btn.removeClass(search_toggle_open);
			} else {
				$(this).html('<span>Close</span>');
				$main_navigation.show();
				$(this).addClass(menu_toggle_open).attr('aria-expanded', 'true');
			}
		});

		// Sub menu toggle
		$menu_item_children_link.unbind().click(function(e) {
			e.preventDefault();

			const $sub_menu = $(this).siblings('.sub-menu');

			$sub_menu.toggle();
			$(this).toggleClass('sub-menu-open');

			if ($sub_menu.is(':visible')) {
				$(this).attr('aria-expanded', 'true');
			} else {
				$(this).attr('aria-expanded', 'false');
			}
		});
	} else {

		$menu_item_children_link.hover(function() {

			$(this).attr('aria-expanded', 'true');

		}, function() {

			$(this).attr('aria-expanded', 'false');

		});

	}
};
